import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { UnassignInboundEmailMutation } from '@/gql/graphql';

const UNASSIGN_INBOUND_EMAIL_MUTATION = graphql(`
  mutation UnassignInboundEmail($inboundEmailId: ID!) {
    unassignInboundEmail(inboundEmailId: $inboundEmailId) {
      id
      status
    }
  }
`);

const useUnassignInboundEmail = (
  options?: UseMutationOptions<
    UnassignInboundEmailMutation,
    unknown,
    { inboundEmailId: string }
  >
) => {
  return useMutation({
    mutationFn: ({ inboundEmailId }) => {
      return gqlClient.request(UNASSIGN_INBOUND_EMAIL_MUTATION, {
        inboundEmailId,
      });
    },
    ...options,
  });
};

export default useUnassignInboundEmail;
